/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_All_Voices_LabelInputs */

const en_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Voices`)
};

const fr_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les voix`)
};

const de_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Stimmen`)
};

const it_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le voci`)
};

const ru_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все голоса`)
};

const es_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las voces`)
};

const zh_cn2_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有人的声音`)
};

const ja_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての声`)
};

const hi_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी आवाजें`)
};

const pt_pt2_voice_manager_all_voices_label = /** @type {(inputs: Voice_Manager_All_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as vozes`)
};

/**
* | output |
* | --- |
* | "All Voices" |
*
* @param {Voice_Manager_All_Voices_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_all_voices_label = /** @type {((inputs?: Voice_Manager_All_Voices_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_All_Voices_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_all_voices_label(inputs)
	if (locale === "de") return de_voice_manager_all_voices_label(inputs)
	if (locale === "it") return it_voice_manager_all_voices_label(inputs)
	if (locale === "ru") return ru_voice_manager_all_voices_label(inputs)
	if (locale === "es") return es_voice_manager_all_voices_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_all_voices_label(inputs)
	if (locale === "ja") return ja_voice_manager_all_voices_label(inputs)
	if (locale === "hi") return hi_voice_manager_all_voices_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_all_voices_label(inputs)
	return en_voice_manager_all_voices_label(inputs)
});